import { Link } from "react-router-dom";

/**
 * A person's name on a row of one of the rail's lists ("My calls today", "Missed calls"), as the
 * way to their contact when the call names one.
 *
 * The link is the name, so a screen reader hears a link called by the person, and it is stretched
 * over the whole row (`after:absolute after:inset-0`, against the row: `RAIL_LIST_ROW` in
 * `softphone/rail.ts`), so a press anywhere on the row opens the contact. A control on the same
 * row (a missed call's Call back) is drawn `relative` and after the link, which keeps it over the
 * stretch and pressed for itself; a button inside a link would be neither.
 *
 * A call that names no contact (a colleague's extension, a number nobody has a record of) is the
 * name in plain text.
 */
export function ContactRowLink({
  leadId, name, onNavigate,
}: {
  /** The contact the call was with, when the platform knows one. */
  leadId: string | null;
  name: string;
  /** The rep followed the link: the popover around the list closes itself. */
  onNavigate?: () => void;
}) {
  if (!leadId) return <>{name}</>;
  return (
    <Link
      to={`/contacts/${leadId}`}
      title="Open the contact"
      className="after:absolute after:inset-0 hover:underline"
      onClick={onNavigate}
    >
      {name}
    </Link>
  );
}
